










import Vue from 'vue';
export default Vue.extend({
  name: 'AppNav',
  data() {
    return {
      routes: [
        {
          text: 'Form example',
          name: 'FormExample',
          key: 'form-example',
        },
      ],
    };
  },
});
